module.exports = __webpack_public_path__ + "assets/aae5f100b8ede2fdadeebb81e3d8cf82.png";